import { FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import clsx from 'clsx'
import { DataLoading } from '../../../../../_dashboard/partials/components/loading/DataLoading'
import { createOne, getAll, getOneByIdbylang, updateOne } from '../../../../services/common_requests'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ID, isNotEmpty, QUERIES } from '../../../../../_dashboard/helpers'
import { Section, SectionTranslation } from '../../pages-list/core/_models'
import { useQueryRequest } from '../../pages-list/core/QueryRequestProvider'
import { useListView } from '../../pages-list/core/ListViewProvider'
import { useQueryResponse } from '../../pages-list/core/QueryResponseProvider'
import { useQueryClient } from 'react-query'
type Props = {
  isSectionLoading: boolean
  Section: Section,
  pageId: ID,
  onSuccess: () => void
  onClose: () => void
}

const editSectionSchema = Yup.object().shape({

  translations: Yup.array().of(
    Yup.object().shape({
      title: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Title is required'),
        time: Yup.number()
        .nullable()
        .typeError('Time must be a number') // Show error if not a number
        .positive('Time must be a positive number'), // Optional: Add additional validation

    })
  ),
   //  position: Yup.number()
  //.typeError('La position doit être un nombre')
 // .positive('La position doit être supérieure à zéro')
// .integer('La position doit être un entier')
 // .required('La position est requise'),*/}
});

const SliderEditModalForm: FC<Props> = ({ Section, isSectionLoading, pageId, onSuccess, onClose }) => {
  const LANGUAGE_NAMES: { [key: string]: string } = {
    en: useIntl().formatMessage({ id: 'COMMON.ENGLISH_LANGUAGE' }),
    fr: useIntl().formatMessage({ id: 'COMMON.FRENSH_LANGUAGE' }),
    es: useIntl().formatMessage({ id: 'COMMON.ESPANGOL_LANGUAGE' }),
    de: useIntl().formatMessage({ id: 'COMMON.GERMAN_LANGUAGE' }),
    ar: useIntl().formatMessage({ id: 'COMMON.ARABIC_LANGUAGE' }),
  };
  const { itemIdForUpdate, setItemIdForUpdate } = useListView()
  const queryClient = useQueryClient()
  const { state } = useQueryRequest();
  const [query, setQuery] = useState<any>(state);
  const [languages, setLanguages] = useState<{ code: string; name: string }[]>([]);
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  useEffect(() => {
    getAll(query, '/languages').then((data) => {
      if (data && Array.isArray(data)) {
        const formattedLanguages = data.map((code: string) => ({
          code,
          name: LANGUAGE_NAMES[code] || code.toUpperCase(),
        }));
        setLanguages(formattedLanguages);
      }
    });
  }, [query]);



  const { refetchData } = useQueryResponse()
  const intl = useIntl()
  const [SectionForEdit] = useState<Section & { translations: SectionTranslation[] }>({
    ...Section,
    translations: Section.translations ?? [{ language: 'en', name: '' }]

  })

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetchData()
    }
    onClose()
    setItemIdForUpdate(undefined)
    setTimeout(() => {
      const modalElement = document.getElementById('kt_modal_add_section_form');
      if (modalElement) {
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
      }
    }, 100);
  }
  const formik = useFormik({
    initialValues: SectionForEdit,
    validationSchema: editSectionSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)

      const payload = {
        //title: values.translations[0].title,
        type: 'slider',
        time: Number(values.time), // Convert time to number
        pageId: pageId,
        translations: values.translations.map(translation => ({
          language: translation.language || 'en',
          title: translation.title,
        })),
      };
      try {

        await createOne(payload, '/blocks').then((response) => {
          if (response?.payload?.code === 2021) {
            queryClient.invalidateQueries(['sections', pageId]) 
            toast.success(
              intl.formatMessage({
                id: 'ADMIN.COMMON.SUCCESS.SECTION_ADDED_SUCCESSFULLY',
              }),
              {
                position: 'top-right',
                autoClose: 4000,
              }
            );
            queryClient.invalidateQueries([QUERIES.SECTION_LIST, pageId])

            cancel(true)
            onSuccess()
            refetchData()
          }
          else if (response?.payload?.code === 4400) {
            toast.error(
              intl.formatMessage({
                id: 'ADMIN.COMMON.ERROR.POSITON_ALREADY_EXIST',
              }),
              {
                position: 'top-right',
                autoClose: 4000,
              }
            );
            onClose()
          }
          else if (response?.payload?.code === 4007) {
            toast.error(
              intl.formatMessage({
                id: 'ADMIN.COMMON.ERROR.INVALID_POSITION',
              }),
              {
                position: 'top-right',
                autoClose: 4000,
              }
            );
            onClose()
          }
          else {
            toast.error(
              intl.formatMessage({
                id: 'ADMIN.COMMON.ERROR.ERROR_ADDING_SLIDER',
              }),
              {
                position: 'top-right',
                autoClose: 4000,
              }
            );
            onClose()
          }
        })
      }
      catch (ex) {
        console.error(ex)
        toast.error(
          intl.formatMessage({
            id: 'ADMIN.COMMON.ERROR.ERROR_ADDING_SLIDER',
          }),
          {
            position: 'top-right',
            autoClose: 4000,
          }
        );

      } finally {
        setSubmitting(false);
        cancel(true)

      }
    }
  },
  )
  const selectedTranslation = formik.values.translations.find(t => t.language === selectedLanguage);

  return (
    <>
      <form
        id='kt_modal_add_section_form'
        className='form'
        onSubmit={formik.handleSubmit}
        noValidate
      >
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n15 pe-6'
          id='kt_modal_add_section_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_section_header'
          data-kt-scroll-wrappers='#kt_modal_add_section_scroll'
          data-kt-scroll-offset='300px'
        >
          {/* begin::Input group */}
          <div className='fv-row mb-4'>
            <label className='required fw-bold fs-6 mb-2'>
              {intl.formatMessage({ id: 'COLUMNS.LANGUAGE' })}
            </label>
            {formik.values.translations.map((translation, index) => (
              <div key={index}>
                <select
                  id={`translations[${index}].language`}
                  name={`translations[${index}].language`}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setSelectedLanguage(e.target.value); // Met à jour la langue sélectionnée
                  }}
                  value={translation.language}

                  className='form-select'
                >
                  {languages.map((lang) => (
                    <option key={lang.code} value={lang.code}>
                      {lang.name}
                    </option>
                  ))}
                </select>
                {formik.errors.translations && (formik.errors.translations[index] as { language?: string })?.language && (
                  <div>{(formik.errors.translations[index] as { language: string }).language}</div>
                )}
              </div>
            ))}
          </div>
          {/* end::Input group */}

          {/* begin::Input group */}
          <div className='fv-row mb-4'>
            {/* begin::Label */}
            <label className='required fw-bold fs-6 mb-2'>
              {intl.formatMessage({ id: 'COLUMNS.NAME' })}
            </label>
            {/* end::Label */}

            {/* begin::Input */}
            <input
              placeholder={intl.formatMessage({ id: 'COLUMNS.NAME' })}
              value={selectedTranslation?.title || ''}
              onChange={(e) => {
                const index = formik.values.translations.findIndex(t => t.language === selectedLanguage);
                if (index !== -1) {
                  formik.setFieldValue(`translations[${index}].title`, e.target.value);
                }
              }}
              type="text"
              name="title"
              className={clsx(
                'form-control mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.translations?.[0]?.title && (formik.errors.translations?.[0] as { title?: string })?.title },
                { 'is-valid': formik.touched.translations?.[0]?.title && !(formik.errors.translations?.[0] as { title?: string })?.title }
              )}
              autoComplete="off"
              disabled={formik.isSubmitting || isSectionLoading}
            />

            {/* end::Input */}
          </div>

          <div className='fv-row mb-4'>
            {/* begin::Label */}
            <label className='fw-bold fs-6 mb-2'>
              {intl.formatMessage({ id: 'COLUMNS.TIME' })}
            </label>
            {/* end::Label */}

            {/* begin::Input */}
            <input
                placeholder={intl.formatMessage({id: 'COLUMNS.TIME'})}
                value={formik.values.time || ''} 
                onChange={(e) => {
                  formik.setFieldValue('time', e.target.value || null); 
                  formik.setFieldTouched('time', true);
                }}
                onBlur={formik.handleBlur}
                type='text'
                name='time'
                className={clsx(
                  'form-control mb-3 mb-lg-0',
                  {
                    'is-invalid': formik.touched.time && formik.errors.time, 
                  },
                  {
                    'is-valid': formik.touched.time && !formik.errors.time,
                  }
                )}
                autoComplete='off'
                disabled={formik.isSubmitting || isSectionLoading}
              />

            {/* end::Input */}
          </div>
          {/* end::Input group */}
          {/*  <div className='fv-row mb-4'>
            <label className='required fw-bold fs-6 mb-2'>
              {intl.formatMessage({ id: 'COLUMNS.POSITION' })}
            </label>

            <input
              type="number"
              min="1"
              className={clsx(
                'form-control mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.position && formik.errors.position },
                { 'is-valid': formik.touched.position && !formik.errors.position }
              )}
              placeholder={intl.formatMessage({ id: 'COLUMNS.POSITION' })}
              {...formik.getFieldProps('position')}
              disabled={formik.isSubmitting || isSectionLoading}
            />

            {formik.touched.position && formik.errors.position && (
              <div className='fv-plateen-help-block text-danger'>

              </div>
            )}
          </div>*/}
        </div>
        {/* end::Scroll */}

        {/* begin::Actions */}
        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => {
              cancel();
              onClose()
              document.getElementById('kt_modal_add_section_form')?.classList.remove('show');
            }}
            className='btn btn-light me-3'
            data-kt-sections-modal-action='cancel'
            disabled={formik.isSubmitting || isSectionLoading}
          >
            {intl.formatMessage({ id: 'HEADER.RESET' })}
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-users-modal-action='submit'
            disabled={
              isSectionLoading || formik.isSubmitting || !formik.isValid || !formik.touched
            }
          >
            <span className='indicator-label'> {intl.formatMessage({ id: 'HEADER.SAVE' })}
            </span>
            {(formik.isSubmitting || isSectionLoading) && (
              <span className='indicator-progress'>
                {intl.formatMessage({ id: 'COMMON.PLEASE_WAIT' })}{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Actions */}
      </form>
      {(formik.isSubmitting || isSectionLoading) && <DataLoading />}
    </>
  )
}

export { SliderEditModalForm }
